import './EmptyPageBacksplash.pcss';
import React from 'react';
import classNames from 'classnames';

type Props = {
  pageIcon: string;
  children?: React.ReactNode | string;
  className?: string;
};

const EmptyPageBacksplash = (props: Props) => {
  const { pageIcon, children, className } = props;

  return (
    <div className={classNames('empty-page-backsplash', className)}>
      <img
        src={pageIcon}
        alt="Empty Page Icon"
        className="empty-page-backsplash__page-icon"
      />

      {children && (
        <div className="empty-page-backsplash__bottom-area">{children}</div>
      )}
    </div>
  );
};

export default EmptyPageBacksplash;
